import { VueEditor, Quill } from "vue2-editor";
import QuillResize from 'quill-image-resize-vue';

Quill.register('modules/resize', QuillResize);

Vue.component('text-editor', {
    props: ['model', 'textkey'],
    data() {
        return {
            editorSettings: {
                modules: {
                    resize: {
                        modules: [ 'Resize', 'Toolbar' ]
                    },
                }
            }
        }
    },
    methods: {
        handleImageAdded(file, Editor, cursorLocation, resetUploader) {
            var formData = new FormData();
            formData.append('file', file);

            axios.post('/image-upload', formData)
                 .then(response => {
                    Editor.insertEmbed(cursorLocation, 'image', response.data);
                 });
        },
    },
    mounted() {
        //
    }
});